<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-4 searching">
                                <span class="h_page">Laporan Rencana Aksi</span> <br> <br>
                            </div>
                            <div class="col-md-5">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button  @click="Printing"  type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data"><i class="material-icons">print</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">
                            <div class="col-md-4">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Tahun</span>
                                <select class="form-control" v-model="form.tahun" @change="getSetupRenstra()">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_tahun" :key="data.id" :value="data.tahun">{{data.tahun}}</option>
                                </select>
                            </div>

                            <div class="col-md-4">
                                <span class="huruf_input">Jenis Renja</span>
                                <select class="form-control" v-model="form.renja_setup_id">
                                    <option value="" selected> -- Pilih Tahun --</option> 
                                    <option v-for="data in list_renja_setup" :key="data.renja_setup_id" :value="data.renja_setup_id">{{data.renja_jenis}}</option>
                                </select>
                            </div>

                            

                        </div>
                        <br>

                        <hr>

                        <div id="printMe">
                            <div>
                                <table style="width: 100%">
                                    <tr>
                                        <td style="width: 10%" class="text-right">
                                            <img src="images/logo konsel.png" alt="" width="50">
                                        </td>
                                        <td style="width: 80%" class="text-center h_kop_1">
                                            <b>
                                                    {{unit_kerja_full}}<br>
                                                    <!-- PERIODE {{renstraku.periode}} -->
                                            </b>
                                        </td >
                                        <td style="width: 10%"></td>
                                    </tr>
                                </table>

                                <hr>
                            </div>



                            
                            <br>
                            <div class="table-responsive">
                                <table class="table-kiken" style="width: 100%">
                                    <thead>
                                    <tr class="bg-success kepala_table_f tabel_center">

                                        <th class="text-center" rowspan="2" style="width: 5%">Kode</th>
                                        <th class="text-center" rowspan="2" style="width: 40%">Program/Kegiatan</th>
                                        <!-- <th class="text-center" rowspan="2" style="width: 10%">Anggaran<br>Renja</th> -->
                                        <th class="text-center" colspan="2" style="width: 5%">Target</th>
                                        <th class="text-center" colspan="2" style="width: 5%">Realisasi</th>
                                        <th class="text-center" rowspan="2" style="width: 30%">Pelaksana</th>

                                    </tr>
                                    <tr class="bg-success kepala_table_f tabel_center">

                                        <!-- <th class="text-center" style="width: 5%">Kode</th> -->
                                        <!-- <th class="text-center" style="width: 40%">Program/Kegiatan</th> -->
                                        <!-- <th class="text-center" style="width: 10%">Anggaran<br>Renja</th> -->
                                        <th class="text-center" >Anggaran</th>
                                        <th class="text-center" >Kegiatan</th>
                                        <th class="text-center" >Anggaran</th>
                                        <th class="text-center" >Kegiatan</th>
                                        <!-- <th class="text-center" style="width: 30%">Pelaksana</th> -->
                                        <!-- <th class="text-center" style="width: 10%">#</th> -->
                                    </tr>
                                    </thead>
                                    <tbody class="tabel_center" >
                                        <template v-for="data in list_data">
                                            <tr class="h_isitable cetak_col_kop" :key="data.renja_program_id">
                                                <td class="tabel_center">{{data.program_kode}}</td>
                                                <td class="tabel_center" colspan="8">{{data.program_nama}}</td>
                                            </tr>
                                            <template v-for="data1 in data.kegiatan">
                                                <tr class="h_isitable" :key="data1.kegiatan_id">
                                                    <td class="tabel_center">{{data.program_kode}}.{{data1.kegiatan_kode}}</td>
                                                    <td class="tabel_center">{{data1.kegiatan_nama}}</td>
                                                    <!-- <td class="tabel_center">{{format_uang(data1.TOTAL)}}</td> -->
                                                    <td class="tabel_center" >{{format_uang(data1.total_target_serapan_anggaran)}}</td>
                                                    <td class="tabel_center text-center" >{{pembulatan_keatas(data1.total_target_serapan_kegiatan)}}%</td>
                                                    <td class="tabel_center" >{{format_uang(data1.total_serapan_anggaran)}}</td>
                                                    <td class="tabel_center text-center" >{{pembulatan_keatas(data1.total_serapan_kegiatan)}}%</td>
                                                    <td class="tabel_center" >
                                                        <ul>
                                                            <template  v-for="data2 in data1.pejabat" >
                                                                <li :key="data2.jabatan_id" v-if="data2.jabatan_nama != null">
                                                                    {{data2.jabatan_nama}}&nbsp; 
                                                                    <!-- <button type="button" class="btn bg-orange btn-xs " title="Hapus Data">x</button> -->
                                                                    <!-- <a href="javascript:void(0);" title="Hapus Data" @click="removeData(data2.sakip_delegasi_lv2_id)">
                                                                        <span class="label label-danger">X</span>
                                                                    </a>     -->
                                                                </li>
                                                            </template>
                                                        </ul>
                                                    </td>
                                                
                                                </tr>
                                            </template>
                                        </template>

                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <hr>
                        <!-- ============================================================ MODAL ======================================================================== -->



                        
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>



<script>

    const ADD_URL = URL_APP+'api/v1/sakip_delegasi_lv2/';
    const ADD_URL_RA = URL_APP+'api/v1/sakip_realisasi_kinerja_keuangan/';


    const ADD_URL_SETUP_RENSTRA = URL_APP+'api/v1/planning_renja_setup/';
    const ADD_URL_TAHUN = URL_APP+'api/v1/planning_tahun/';

    const URL_JABATAN = URL_APP+'api/v1/simpeg_jabatan/';



    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "",
        components: { Autocomplete },
        data() {
            return {
                form : {
                    jabatan_id : '',
                    target : 0,
                    keterangan : '',

                    renja_kegiatan_id : '',

                    renja_setup_id : '',
                    tahun : '',
                    instansi_id : '',
                    unit_kerja : '',
                },

                jadual : {
                    sakip_rencana_aksi_lv1_jadual_id : '',
                    renja_kegiatan_id : '',
                    jan : false,
                    feb : false,
                    mar : false,
                    apr : false,
                    mei : false,
                    jun : false,
                    jul : false,
                    agu : false,
                    sep : false,
                    okt : false,
                    nov : false,
                    des : false,
                },
                serapan : {
                    sakip_rencana_aksi_lv1_realisasi_serapan_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                },
                kegiatan : {
                    sakip_rencana_aksi_lv1_kegiatan_serapan_id : '',
                    renja_kegiatan_id : '',
                    jan : 0,
                    feb : 0,
                    mar : 0,
                    apr : 0,
                    mei : 0,
                    jun : 0,
                    jul : 0,
                    agu : 0,
                    sep : 0,
                    okt : 0,
                    nov : 0,
                    des : 0,
                },

                rencana : {
                    sakip_rencana_aksi_lv1_id : '',
                    uraian : '',
                    renja_kegiatan_id : '',
                },

                unit_kerja : '',
                unit_kerja_full : '',
                instansi_id : '',


                list_renja_setup :[],

                list_data : [],
                list_rencana : [],
                list_jadual : {},

                check_data_add : false,
                page_first : 1,
                page_last : 0,
                cari_value : '',

                list_tahun : [],
                list_jabatan : [],

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;
            this.form.unit_kerja = get_profile.profile.unit_kerja;

            this.form.instansi_id = get_profile.profile.instansi_id;
            this.instansi_id = get_profile.profile.instansi_id;

            this.getData();

            localStorage.sidemenu = 'sakip';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                // console.log(this.unit_kerja);
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      renja_setup_id : this.form.renja_setup_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data;
                  console.log(res_data);
                })
            },


            selectData : function(data){
                // console.log(data);

                this.form.renja_kegiatan_id = data.renja_kegiatan_id;
                this.form.renja_setup_id = data.renja_setup_id;
                this.form.tahun = data.tahun;
                this.form.instansi_id = data.instansi_id;
                this.form.unit_kerja = data.unit_kerja;

                this.rencana.renja_kegiatan_id = data.renja_kegiatan_id;
                this.jadual.renja_kegiatan_id = data.renja_kegiatan_id;
                this.serapan.renja_kegiatan_id = data.renja_kegiatan_id;
                this.kegiatan.renja_kegiatan_id = data.renja_kegiatan_id;


                this.getDataTahun();

            },



            emptyData : function(){

            },



        //TAMBAHAN
            getSetupRenstra : function(){
                fetch(ADD_URL_SETUP_RENSTRA, {
                    method : 'POST',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja,
                        tahun : this.form.tahun,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    this.list_renja_setup = res_data;

                    if (res_data.length <= 0) {
                        this.form.renja_setup_id = '';
                        this.check_data_add = false;
                    }else{
                        this.form.renja_setup_id = res_data[0].renja_setup_id
                        this.getData();
                    }

                    // console.log(res_data[0]);
                })
            },



            check_kegiatan : function(data){
                if (data == null || data == undefined || data == ''|| data == false|| data == 0) {
                    return true
                }else{
                    return false
                }
            },




        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.list_data = [];
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.form.unit_kerja = obj.id;


                this.form.instansi_id = obj.instansi_id;
                this.instansi_id = obj.instansi_id

                this.getDataTahun();
                console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                
                if (this.form.renja_setup_id != '') {
                    this.check_data_add = true;
                }
            },
            getDataTahun: function(){
                fetch(ADD_URL_TAHUN, {
                    method : 'GET',
                    headers : {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                }).then((res) => res.json()).then((res_data) => {
                    this.list_tahun = res_data;
                    this.form.tahun = this.getTgl().tahun;
                    // console.log(res_data);

                    this.getSetupRenstra();
                })
            },
            getTgl : function(){
                var d = new Date();
                return {
                    tahun : d.getFullYear(),
                }
            },
            format_uang : function(nilai, prefix){
                var angka = parseFloat(nilai)
                if (nilai == null || nilai == '' || nilai == undefined || nilai == 0 || nilai == 'NaN') {
                    if (angka == Number.isNaN(NaN)) {
                        return '0';
                    } else {
                        return 0;
                    }
                } else {
                    return (angka).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
                }
            },
            Printing : function(){
                // printMe
                var elem = document.getElementById("printMe");
                var domClone = elem.cloneNode(true);

                var $printSection = document.getElementById("printSection");

                if (!$printSection) {
                    var $printSection = document.createElement("div");
                    $printSection.id = "printSection";
                    document.body.appendChild($printSection);
                }

                $printSection.innerHTML = "";
                $printSection.appendChild(domClone);
                window.print();

            },
            pembulatan_keatas : function(data){
                return Math.ceil(data)
            },

        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
